import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

interface PostUserPasswordResetTokenResponse {
  message: string;
}

/**
 * 비밀번호 재설정 요청
 */
// eslint-disable-next-line import/prefer-default-export
export function postUserPasswordResetToken(email: string): Promise<{ message: string }> {
  return requestApi<PostUserPasswordResetTokenResponse>({
    url: withIdentityAccess('/user/password/reset/token'),
    method: 'POST',
    data: {
      email,
    },
  }).then((response) => response.data);
}
